module.exports = __webpack_public_path__ + "img/a-loading-primary.121c282a.svg";